import {
  Button, Flex,
  Link,
  Td,
  Text,
  Tr
} from '@chakra-ui/react'
import type { OneVehicleIdentificationDto, VehicleValuationDto } from 'BrokerTsLib/src/dtos'
import { usePriceFormat } from '@/hooks/usePriceFormat'
import { formatDate } from 'BrokerTsLib/src/Utils/formatPrice'
import { useState } from 'react'
import { useVehicleValuation } from '../../../../../../../hooks/useVehicle'
import type { VehiclePriceTableProps } from './VehiclePriceTable'


export const VehiclePriceTableRow = ({
  vehicle,
  tableProps
}: {
  vehicle: OneVehicleIdentificationDto,
  tableProps: VehiclePriceTableProps

}) => {
  const {
    onUsePriceButtonClick,
    paramsId,
    licensePlate,
    vin,
    firstRegistrationDate,
    mileage
  } = tableProps

  const {
    id,
    saleFrom,
    saleTo,
    priceWithEquipment
  } = vehicle

  const { mutateAsync: refetchValuation, isPending: isLoadingValuation } = useVehicleValuation()
  const { priceFormat } = usePriceFormat()
  const [valuationData, setValuationData] = useState<VehicleValuationDto | null>(null)

  const valuationError = !!valuationData?.error

  return (
    <>
      <Tr>
        <Td borderBottom={valuationData ? 'none' : undefined}>
          <Text sx={{ fontWeight: 'bold' }}>{vehicle.description}</Text>
          <Flex sx={{ gap: 2 }}>
            <Link variant="underline" href={vehicle.pdfLink} target="_blank">
              pdf
            </Link>
          </Flex>
        </Td>
        <Td borderBottom={valuationData ? 'none' : undefined}>
          <Text>
            {typeof saleFrom === 'string'
              ? saleFrom
              : formatDate(saleFrom as Date)}
          </Text>
          <Text>
            {typeof saleTo === 'string'
              ? saleTo
              : formatDate(saleTo as Date)}
          </Text>
        </Td>
        <Td verticalAlign="bottom" borderBottom={valuationData ? 'none' : undefined}>
          {priceWithEquipment &&
            <Text sx={{ fontWeight: 'bold' }}>
              {priceFormat(priceWithEquipment)}
            </Text>}
        </Td>
        <Td verticalAlign="bottom" borderBottom={valuationData ? 'none' : undefined}>
          <Button
            variant="link"
            size="sm"
            sx={{ h: 5 }}
            isLoading={isLoadingValuation}
            loadingText='Oceňuji...'
            onClick={() => {
              refetchValuation({
                paramsId,
                licensePlate: licensePlate ?? '',
                vin: vin ?? '',
                vehicleId: id ?? '',
                firstRegistrationDate,
                accSelected: vehicle?.accessoriesOptionalSelected,
                mileage
              })
                .then(({ data }) => {
                  setValuationData(data)
                })
            }}
          >
            Ocenit
          </Button>
        </Td>
      </Tr>
      {valuationData && (
        <Tr>
          <Td colSpan={4}>
            <Flex sx={{ placeItems: 'center', justifyContent: 'center', my: 3, gap: 4 }}>
              {!valuationError &&
                <>
                  <Text as="span" fontWeight='bold'>Obvyklá cena ojetého vozidla</Text>

                  <Flex sx={{ flexWrap: 'wrap', gap: 2 }}>
                    <Button
                      type="button"
                      variant="outline"
                      fontSize='md'
                      py={2}
                      colorScheme="green"
                      onClick={() => onUsePriceButtonClick(valuationData!.vehicleMarketPriceWithTax, true)}
                    >
                      <Text as="span" sx={{ fontWeight: 'bold' }}>
                        {priceFormat(valuationData!.vehicleMarketPriceWithTax)}
                      </Text>
                      s DPH
                    </Button>

                    <Button
                      type="button"
                      variant="outline"
                      fontSize='md'
                      py={2}
                      colorScheme="blue"
                      onClick={() => onUsePriceButtonClick(valuationData!.vehicleMarketPrice, false)}
                    >
                      <Text as="span" sx={{ fontWeight: 'bold' }}>
                        {priceFormat(valuationData!.vehicleMarketPrice)}
                      </Text>
                      bez DPH
                    </Button>
                  </Flex>
                </>}
              {valuationError &&
                <Text as="span">{valuationData.error}</Text>}
            </Flex>
          </Td>
        </Tr>
      )}
    </>

  )
}
